import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import Pagination from '@/components/base/Pagination';
import { categories, getMoviesByCategory, getCategoryName } from '@/mocks/movies';

const ITEMS_PER_PAGE = 8;

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [currentPage, setCurrentPage] = useState(1);

  const categoryName = slug ? getCategoryName(slug) : '';
  const categoryMovies = slug ? getMoviesByCategory(slug) : [];
  const totalPages = Math.ceil(categoryMovies.length / ITEMS_PER_PAGE);
  const paginatedMovies = categoryMovies.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  useEffect(() => {
    setCurrentPage(1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  useEffect(() => {
    document.title = `${categoryName} - 7777影院 | 免费在线观看${categoryName}高清全集`;
  }, [categoryName]);

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: categoryName },
  ];

  return (
    <>
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumbItems} />

          <div className="flex items-center gap-2 mb-6">
            <span className="w-1 h-6 rounded-full bg-primary-500"></span>
            <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              {categoryName}
            </h1>
            <span className="text-sm text-foreground-500 ml-2">
              共 {categoryMovies.length} 部
            </span>
          </div>

          <div className="flex flex-wrap gap-2 mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  slug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-800 border border-background-200'
                }`}
              >
                <i className={`${cat.icon} text-sm`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {categoryMovies.length > 0 ? (
            <>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                {paginatedMovies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} variant="default" />
                ))}
              </div>

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(page) => {
                  setCurrentPage(page);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              />
            </>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
                <i className="ri-movie-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500 text-sm">该分类暂无内容，请浏览其他分类</p>
              <Link
                to="/"
                className="inline-flex items-center gap-1 mt-4 text-sm text-primary-600 hover:text-primary-700 cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i> 返回首页
              </Link>
            </div>
          )}
        </div>
      </main>
    </>
  );
}